import './styles/App.css';
import { TableUI } from './components/air-melt';
import { AirMeltAlloy, AirMeltCategory } from './components/core/alloy-types';

function AirMeltPage(props: any) {
  const { records } = props;

  function processAirtableAirMeltRecords(r: any): AirMeltAlloy {
    const airMeltAlloy: AirMeltAlloy = {
        id: r.fields['id'] as number,
        category: r.fields['category'] as AirMeltCategory,
        cannonMuskegonTitle: r.fields['cannonMuskegonTitle'] as string,
        commonName: r.fields['commonName'] as string,
        tradeName: r.fields['tradeName'] as string,
        astm: r.fields['astm'] as string,
        aerospaceMaterialSpecifications: r.fields['aerospaceMaterialSpecification'] as string,
        uns: r.fields['uns'] as string,
        din: r.fields['din'] as string,
        wNr: r.fields['wNr'] as string,
        afnor: r.fields['afnor'] as string,
        carbon: r.fields['carbon'] as any,
        chromium: r.fields['chromium'] as any,
        cobalt: r.fields['cobalt'] as any,
        copper: r.fields['copper'] as any,
        iron: r.fields['iron'] as any,
        manganese: r.fields['manganese'] as any,
        molybdenum: r.fields['molybdenum'] as any,
        nickel: r.fields['nickel'] as any,
        phosphorus: r.fields['phosphorus'] as any,
        silicon: r.fields['silicon'] as any,
        sulfur: r.fields['sulfur'] as any,
        tungsten: r.fields['tungsten'] as any,
        vanadium: r.fields['vanadium'] as any,
        solidusF: r.fields['solidusF'] as any,
        liquidousF: r.fields['liquidousF'] as any,
        other: r.fields['other'] as any
    };
  
    return airMeltAlloy;
  }

  var airMeltAlloys: AirMeltAlloy[] = records.map((a: any) => processAirtableAirMeltRecords(a));

  return (
    <div className="App">
      <TableUI products={airMeltAlloys}/> 
    </div>
  );
}

export default AirMeltPage;
